"use client";

import Image from "next/image";
import Link from "next/link";

type Props = {
  lang: "fr" | "en";
};

export default function Header({ lang }: Props) {
  const isFr = lang === "fr";
  const FlagFr = (lang === 'fr') ? 'Drapeau français' : 'French flag';
  const FlagEn = (lang === 'fr') ? 'Drapeau anglais' : 'English flag';

  const titleFlag = isFr
    ? "Vers le site version anglaise - Continental Edison - Notices produits"
    : "To the English version of the site - Continental Edison - Product manuals";
  return (
    <div className="m-header-front">
      <div className="container">
        <div className="m-header-front__wrapper">
          <div></div>

          <Image
            width={131}
            height={41}
            className="m-header-front__logo"
            src="/logo-white.svg"
            alt="Continental Edison - Notices"
          />

          <div className="m-header-front__info">
            <a
              href="https://www.continentaledison.fr/"
              className="m-header-front__return"
            >
              {isFr ? "Revenir sur le site Continental Edison" : "Return to Continental Edison"}
            </a>

            <Link
              href={isFr ? "/en" : "/"}
              className="m-header-front__info__lang"
              title={titleFlag}
            >
              <Image
                src={isFr ? "/flag-en.svg" : "/flag-fr.svg"}
                alt={isFr ? FlagEn : FlagFr}
                width={18}
                height={12}
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
